// extracted by mini-css-extract-plugin
module.exports = {"posts":"styles_posts__1-Rk3","active-topics":"styles_active-topics__2h_Xe"};